export default "__VITE_ASSET__CS8IcvB8__"